export default class Server {
  constructor(_id, title, ip, url, port) {
    // eslint-disable-next-line no-underscore-dangle
    this._id = _id
    this.title = title
    this.ip = ip
    this.url = url
    this.port = port
  }
}
